import http from 'utils/http';
import { interpolate } from 'utils/string';
import { REMINDER_LIST_URL, REMINDER_URL_ID, REMINDER_URL } from 'constants/endpoints';
import type { Reminder } from 'interface/reminders';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetchAll(params: ServiceParams) {
  return await http.get(REMINDER_LIST_URL, { params: { ...params } });
}

export async function remove(id: ServiceId) {
  return await http.delete(interpolate(REMINDER_URL_ID, { id }));
}

export async function fetchReminder(id: ServiceId) {
  return await http.get(interpolate(REMINDER_URL_ID, { id }));
}

export async function create(reminder: Reminder) {
  return await http.post(REMINDER_URL, { body: reminder });
}

export async function updateReminder(id: ServiceId, reminder: Reminder) {
  return await http.put(interpolate(REMINDER_URL_ID, { id }), { body: { id, ...reminder } });
}
